import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { ChevronNavLeft } from 'components/CustomSVG';


const BackTo = ({link, title}) => {
  return (
    <div className="flex items-center">
      <Link to={link}>
        <Button
          variant="contained"
          className="py-1 pl-2 pr-1 mr-2 align-center text-center bg-white min-w-auto"
        >
          <ChevronNavLeft className="text-20" />
        </Button>
      </Link>
      {title}
    </div>
  );
};

export default BackTo;
